import * as tslib_1 from "tslib";
// Core packages
import { moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { AfterViewInit, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
// Third party packages
import { MatDialog } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { finalize, take } from "rxjs/operators";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { DocumentSettingDetailDialogComponent } from "src/app/modules/settings/components/document-setting-detail-dialog/document-setting-detail-dialog.component";
import { SettingsService } from "src/app/modules/settings/settings.service";
import { ConfirmDialogComponent } from "src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { ThemeService } from "src/app/shared/services/theme.service";
var DocumentDetailComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function DocumentDetailComponent(configService, activatedRoute, settingsService, router, toastrService, helperService, translateService, themeService, authService, dialog, newMessageDialog, cookieService) {
        this.configService = configService;
        this.activatedRoute = activatedRoute;
        this.settingsService = settingsService;
        this.router = router;
        this.toastrService = toastrService;
        this.helperService = helperService;
        this.translateService = translateService;
        this.themeService = themeService;
        this.authService = authService;
        this.dialog = dialog;
        this.newMessageDialog = newMessageDialog;
        this.cookieService = cookieService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // BEGIN - Formly config
        this.form = new FormGroup({});
        this.formSubElement = new FormGroup({});
        this.model = {};
        this.modelSubElement = {};
        this.fields = [];
        this.fieldsSubElement = [];
        this.options = {
            formState: {
                disabled: false,
            },
        };
        this.optionsSubElement = {
            formState: {
                disabled: false,
            },
        };
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.save"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true,
            },
        };
        // END - Formly config
        // BEGIN - Move content form (cross-area move of a 2nd level content/section)
        this.moveContentForm = new FormGroup({
            contentId: new FormControl("", Validators.required),
            destAreaId: new FormControl("", Validators.required),
        });
        // END - Move content form
        this.cardIsLoading = true;
        this.documentTemplateId = "";
        this.documentTemplate = [];
        this.subDocumentTemplateId = "";
        this.subDocumentTemplate = [];
        this.formFirstLevelIsVisible = false;
        this.formNewIsVisible = false;
        this.formNewSubElementIsVisible = false;
        this.currentItemTitle = "";
        this.currentItemId = "";
        this.condoStructureTemplate = [];
    }
    /**
     * Init components
     *
     * @since 1.0.0
     */
    DocumentDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Set page title
        this.themeService.setPageTitle(this.translateService.instant("companies.detail.pageTitle"));
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return (_this.loggedUser = res); }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return (_this.loggedUserPermissions = res); }));
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
    };
    /**
     * After view init logic
     *
     * @since 1.0.0
     */
    DocumentDetailComponent.prototype.ngAfterViewInit = function () {
        this.onGetDocument();
    };
    /**
     * Get document template
     *
     * @since 1.0.0
     */
    DocumentDetailComponent.prototype.onGetDocument = function () {
        var _this = this;
        this.subscriptions.push(this.settingsService.getDocument().subscribe(function (res) {
            if (res.status) {
                if (res.data &&
                    Array.isArray(res.data) &&
                    res.data.length > 0 &&
                    res.data[0].area &&
                    Array.isArray(res.data[0].area)) {
                    _this.documentTemplateId = res.data[0]._id;
                    _this.documentTemplate = res.data[0].area;
                    _this.onGetCondoStructure();
                }
            }
            _this.cardIsLoading = false;
            if (_this.currentItemId !== "") {
                _this.onTitleClicked(_this.currentItemId);
            }
        }, function (err) {
            _this.helperService.handleError(err);
            _this.cardIsLoading = false;
        }));
    };
    /**
     * Get structure template
     *
     * @since 1.0.0
     */
    DocumentDetailComponent.prototype.onGetCondoStructure = function () {
        var _this = this;
        this.subscriptions.push(this.settingsService.getStructure().subscribe(function (res) {
            var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
            if (res.status) {
                if (res.condoStructureTemplate &&
                    Array.isArray(res.condoStructureTemplate) &&
                    res.condoStructureTemplate.length > 0 &&
                    res.condoStructureTemplate[0].area &&
                    Array.isArray(res.condoStructureTemplate[0].area)) {
                    if (res.condoStructureTemplate[0].area &&
                        Array.isArray(res.condoStructureTemplate[0].area)) {
                        try {
                            for (var _e = tslib_1.__values(res.condoStructureTemplate[0].area), _f = _e.next(); !_f.done; _f = _e.next()) {
                                var structures = _f.value;
                                if (structures &&
                                    structures.content &&
                                    Array.isArray(structures.content)) {
                                    try {
                                        for (var _g = (e_2 = void 0, tslib_1.__values(structures.content)), _h = _g.next(); !_h.done; _h = _g.next()) {
                                            var structure = _h.value;
                                            if (structure && structure.key) {
                                                _this.condoStructureTemplate.push({
                                                    key: structure.key,
                                                    translation: structure.translation,
                                                    used: false,
                                                });
                                            }
                                        }
                                    }
                                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                    finally {
                                        try {
                                            if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                                        }
                                        finally { if (e_2) throw e_2.error; }
                                    }
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                    }
                }
                if (_this.documentTemplate &&
                    Array.isArray(_this.documentTemplate)) {
                    try {
                        for (var _j = tslib_1.__values(_this.documentTemplate), _k = _j.next(); !_k.done; _k = _j.next()) {
                            var docs = _k.value;
                            if (docs &&
                                docs.content &&
                                Array.isArray(docs.content)) {
                                var _loop_1 = function (doc) {
                                    if (doc.elementType === 'array' && doc.structure !== '') {
                                        var index = _this.condoStructureTemplate.findIndex(function (item) { return item.key === doc.structure; });
                                        if (index > -1) {
                                            _this.condoStructureTemplate[index].used = true;
                                        }
                                    }
                                };
                                try {
                                    for (var _l = (e_4 = void 0, tslib_1.__values(docs.content)), _m = _l.next(); !_m.done; _m = _l.next()) {
                                        var doc = _m.value;
                                        _loop_1(doc);
                                    }
                                }
                                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                                finally {
                                    try {
                                        if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                                    }
                                    finally { if (e_4) throw e_4.error; }
                                }
                            }
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                }
            }
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    DocumentDetailComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Handle item click
     *
     * @since 1.0.0
     */
    DocumentDetailComponent.prototype.onTitleClicked = function (itemId) {
        this.currentItemId = itemId;
        this.formNewIsVisible = false;
        this.formNewSubElementIsVisible = false;
        var item = this.documentTemplate.filter(function (el) {
            return el._id.toString() === itemId.toString();
        });
        if (this.model) {
            for (var property in this.model) {
                delete this.model[property];
            }
        }
        var fieldGroup = [];
        fieldGroup.push({
            key: "itemId",
            defaultValue: item[0]._id,
            templateOptions: {
                type: "hidden",
            },
        });
        fieldGroup.push({
            className: "col-12 col-md-12 col-xl-12",
            type: "select",
            key: "group",
            templateOptions: {
                label: this.translateService.instant("settings.document.group"),
                placeholder: this.translateService.instant("settings.document.group"),
                required: true,
                multiple: false,
                options: [
                    {
                        value: "amministrativo",
                        label: "Gestionale amministrativo",
                    },
                    {
                        value: "contratti",
                        label: "Contratti fornitura e servizi",
                    },
                    {
                        value: "tecnico",
                        label: "Tecnica",
                    },
                    {
                        value: "unitaImmobiliari",
                        label: "Unità Immobiliari",
                    },
                ],
            },
        });
        fieldGroup.push({
            className: "col-12 col-md-5 col-xl-5",
            type: "input",
            key: "translation.it",
            defaultValue: "",
            templateOptions: {
                label: this.translateService.instant("settings.document.it"),
                placeholder: this.translateService.instant("settings.document.it"),
                required: true,
                minLength: 2,
                maxLength: 100,
            },
        });
        fieldGroup.push({
            className: "col-12 col-md-5 col-xl-5",
            type: "input",
            key: "translation.en",
            defaultValue: "",
            templateOptions: {
                label: this.translateService.instant("settings.document.en"),
                placeholder: this.translateService.instant("settings.document.en"),
                required: true,
                minLength: 2,
                maxLength: 100,
            },
        });
        fieldGroup.push({
            className: "col-12 col-md-2 col-xl-2",
            type: "select",
            key: "deleted",
            templateOptions: {
                label: this.translateService.instant("settings.document.deleted"),
                placeholder: this.translateService.instant("settings.document.deleted"),
                required: true,
                multiple: false,
                options: [
                    {
                        value: false,
                        label: "No",
                    },
                    {
                        value: true,
                        label: "Sì",
                    },
                ],
            },
        });
        this.currentItemTitle = item[0].translation.it;
        this.model = {
            group: item[0].group,
            deleted: item[0].deleted,
            translation: {
                it: item[0].translation.it,
                en: item[0].translation.en,
            }
        };
        if (item[0].content && Array.isArray(item[0].content)) {
            this.subDocumentTemplateId = item[0]._id;
            this.subDocumentTemplate = item[0].content;
            //   fieldGroup.push({
            //     className: "col-12",
            //     template:
            //       "<hr /><div><strong>" +
            //       this.translateService.instant("settings.document.secondLevel") +
            //       "</strong></div><br />",
            //   });
            //   secondLevel.forEach((el: any, index: number) => {
            //     fieldGroup.push({
            //       key: `content[${index}].id`,
            //       defaultValue: el._id,
            //       templateOptions: {
            //         type: "hidden",
            //       },
            //     });
            //     fieldGroup.push({
            //       className: "col-12 col-md-5 col-xl-5",
            //       type: "input",
            //       key: `content[${index}].it`,
            //       defaultValue: el.translation.it,
            //       templateOptions: {
            //         label: this.translateService.instant("settings.document.it"),
            //         placeholder: this.translateService.instant("settings.document.it"),
            //         required: true,
            //         minLength: 2,
            //         maxLength: 100,
            //       },
            //     });
            //     fieldGroup.push({
            //       className: "col-12 col-md-3 col-xl-3",
            //       type: "input",
            //       key: `content[${index}].en`,
            //       defaultValue: el.translation.en,
            //       templateOptions: {
            //         label: this.translateService.instant("settings.document.en"),
            //         placeholder: this.translateService.instant("settings.document.en"),
            //         required: true,
            //         minLength: 2,
            //         maxLength: 100,
            //       },
            //     });
            //     fieldGroup.push({
            //       className: "col-12 col-md-2 col-xl-2",
            //       type: "select",
            //       key: `content[${index}].deleted`,
            //       defaultValue: el.deleted,
            //       templateOptions: {
            //         label: this.translateService.instant("settings.document.deleted"),
            //         placeholder: this.translateService.instant("settings.document.deleted"),
            //         required: true,
            //         multiple: false,
            //         options: [
            //           {
            //             value: false,
            //             label: "No",
            //           },
            //           {
            //             value: true,
            //             label: "Sì",
            //           },
            //         ],
            //       },
            //     });
            //     fieldGroup.push({
            //       className: "col-12 col-md-2 col-xl-2",
            //       type: "button",
            //       key: "openSubDoc",
            //       templateOptions: {
            //         color: "accent",
            //         // tooltip: "tooltip",
            //         icon: {
            //           fontSet: "fas",
            //           fontIcon: "fa-edit",
            //         },
            //         text: this.translateService.instant("common.cta.open"),
            //         onClick: ($event) => this.onSubTitleClicked(item._id, el),
            //       },
            //     });
            //     // this.model[`sl-${el._id}-it`] = el.it;
            //     // this.model[`sl-${el._id}-en`] = el.en;
            //   });
        }
        this.fields = [
            {
                fieldGroupClassName: "row",
                fieldGroup: fieldGroup,
            },
        ];
        this.formFirstLevelIsVisible = true;
    };
    /**
     * Handle item click
     *
     * @since 1.0.0
     */
    DocumentDetailComponent.prototype.onSubTitleClicked = function (item) {
        var _this = this;
        // Angular CDK 8's drag&drop computes pointer position relative to the window scroll
        // captured when the drag starts; if the page behind the dialog is scrolled down,
        // that offset desyncs the calculation and breaks reordering inside the dialog.
        window.scrollTo(0, 0);
        var dialogRef = this.dialog.open(DocumentSettingDetailDialogComponent, {
            data: {
                documentTemplateId: this.documentTemplateId,
                areaId: this.subDocumentTemplateId,
                subAreaId: item._id,
                item: item,
                condoStructureTemplate: this.condoStructureTemplate,
                // Full first-level areas tree, used to build the cross-content move target list
                areas: this.documentTemplate,
            },
            width: "90%",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            _this.onGetDocument();
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Handle submit form
     *
     * @since 1.0.0
     */
    DocumentDetailComponent.prototype.onFormSubmit = function (model) {
        var _this = this;
        // Prevent invalid form submit
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
            console.warn(this.form);
            return;
        }
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.confirm.title"),
                message: this.translateService.instant("settings.document.dialog.saveMessage"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
            },
            width: "500px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            // Remove blank values from model
            Object.keys(model).forEach(function (key) {
                if (!model[key] || model[key].valueOf() === "") {
                    delete model[key];
                }
            });
            var index = _this.documentTemplate.findIndex(function (el) {
                return el._id === _this.form.value.itemId;
            });
            if (index > -1) {
                _this.documentTemplate[index].group = _this.form.value.group;
                _this.documentTemplate[index].translation = _this.form.value.translation;
                _this.documentTemplate[index].deleted = _this.form.value.deleted;
            }
            _this.cardIsLoading = true;
            var dataToSend = {
                documents: _this.documentTemplate.map(function (el) {
                    return {
                        _id: el._id,
                        group: el.group,
                        translation: el.translation,
                        deleted: el.deleted,
                    };
                }),
            };
            _this.subscriptions.push(_this.settingsService
                .updateDocument(_this.documentTemplateId, undefined, undefined, dataToSend)
                .pipe(finalize(function () { return (_this.cardIsLoading = false); }))
                .subscribe(function (res) {
                if (res) {
                    _this.onGetDocument();
                    _this.toastrService.success(res.message);
                }
            }, function (err) {
                // Choose one of the following error handling method.
                // 1) First one show a message right under the form fields
                //    (if the form is properly setted)
                // 2) Second one is used to show a mat-error under each field
                //    in the dynamic form (is meant to be used only in dynamicForm)
                // 3) Third one show toastr notifications for each error
                // 4) Fourth one is used to show mat-error under each field
                //    in the ngx-formly form (is mean to be used only with ngx-formly)
                // this.helperService.handleFormError(form, err);
                // this.helperService.handleDynamicFormError(form, err);
                _this.helperService.handleError(err);
                _this.helperService.handleFormlyError(_this.form, err);
            }));
        });
    };
    /**
     * Handle drag&drop
     *
     * @since 1.0.0
     */
    DocumentDetailComponent.prototype.drop = function (event) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        }
        else {
            transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
        }
    };
    /**
     * Handle save document template first level
     *
     * @since 1.0.0
     */
    DocumentDetailComponent.prototype.onSaveDocumentTemplate = function () {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.confirm.title"),
                message: this.translateService.instant("settings.document.dialog.saveMessage"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
            },
            width: "500px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            _this.cardIsLoading = true;
            var dataToSend = {
                documents: _this.documentTemplate.map(function (el) {
                    return {
                        _id: el._id,
                        group: el.group,
                        translation: el.translation,
                        deleted: el.deleted,
                    };
                }),
            };
            _this.subscriptions.push(_this.settingsService
                .updateDocument(_this.documentTemplateId, undefined, undefined, dataToSend)
                .pipe(finalize(function () { return (_this.formBtnOptions.active = false); }))
                .subscribe(function (res) {
                _this.onGetDocument();
                _this.toastrService.success(res.message);
                _this.cardIsLoading = false;
            }, function (err) {
                // Choose one of the following error handling method.
                // 1) First one show a message right under the form fields
                //    (if the form is properly setted)
                // 2) Second one is used to show a mat-error under each field
                //    in the dynamic form (is meant to be used only in dynamicForm)
                // 3) Third one show toastr notifications for each error
                // 4) Fourth one is used to show mat-error under each field
                //    in the ngx-formly form (is mean to be used only with ngx-formly)
                // this.helperService.handleFormError(form, err);
                // this.helperService.handleDynamicFormError(form, err);
                _this.helperService.handleError(err);
                _this.cardIsLoading = false;
            }));
        });
    };
    /**
     * Handle save document template second level
     *
     * @since 1.0.0
     */
    DocumentDetailComponent.prototype.onSaveSubDocumentTemplate = function () {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.confirm.title"),
                message: this.translateService.instant("settings.document.dialog.saveMessage"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
            },
            width: "500px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            _this.cardIsLoading = true;
            var dataToSend = {
                documents: _this.subDocumentTemplate.map(function (el) {
                    return {
                        _id: el._id,
                        translation: el.translation,
                        deleted: el.deleted,
                    };
                }),
            };
            _this.subscriptions.push(_this.settingsService
                .updateDocument(_this.documentTemplateId, _this.subDocumentTemplateId, undefined, dataToSend)
                .pipe(finalize(function () { return (_this.formBtnOptions.active = false); }))
                .subscribe(function (res) {
                _this.onGetDocument();
                _this.toastrService.success(res.message);
                _this.cardIsLoading = false;
            }, function (err) {
                // Choose one of the following error handling method.
                // 1) First one show a message right under the form fields
                //    (if the form is properly setted)
                // 2) Second one is used to show a mat-error under each field
                //    in the dynamic form (is meant to be used only in dynamicForm)
                // 3) Third one show toastr notifications for each error
                // 4) Fourth one is used to show mat-error under each field
                //    in the ngx-formly form (is mean to be used only with ngx-formly)
                // this.helperService.handleFormError(form, err);
                // this.helperService.handleDynamicFormError(form, err);
                _this.helperService.handleError(err);
                _this.cardIsLoading = false;
            }));
        });
    };
    /**
     * Handle move of the selected second-level content (section) to another area.
     * Source area is the currently opened area; destination is picked from the form.
     *
     * @since 3.0.0
     */
    DocumentDetailComponent.prototype.onMoveContentSubmit = function () {
        var _this = this;
        if (this.moveContentForm.invalid) {
            Object.keys(this.moveContentForm.controls).forEach(function (key) {
                _this.moveContentForm.controls[key].markAsTouched();
            });
            this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
            return;
        }
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.confirm.title"),
                message: this.translateService.instant("settings.document.move.confirmMessage"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
            },
            width: "500px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (confirmed) {
            if (!confirmed) {
                return;
            }
            var sourceAreaId = _this.subDocumentTemplateId;
            var contentId = _this.moveContentForm.value.contentId;
            var destAreaId = _this.moveContentForm.value.destAreaId;
            _this.cardIsLoading = true;
            _this.subscriptions.push(_this.settingsService
                .moveDocumentContent(_this.documentTemplateId, sourceAreaId, destAreaId, contentId)
                .pipe(finalize(function () { return (_this.cardIsLoading = false); }))
                .subscribe(function (result) {
                if (result && result.status) {
                    _this.toastrService.success(result.message);
                    _this.moveContentForm.reset();
                    // Reload the template; the moved content disappears from this area
                    _this.onGetDocument();
                }
            }, function (err) {
                _this.helperService.handleError(err);
            }));
        });
    };
    /**
     * Handle add new document area
     *
     * @since 1.0.0
     */
    DocumentDetailComponent.prototype.onAddDocumentTemplate = function () {
        this.currentItemId = "";
        this.formNewIsVisible = false;
        this.formFirstLevelIsVisible = false;
        this.formNewSubElementIsVisible = false;
        if (this.model) {
            for (var property in this.model) {
                delete this.model[property];
            }
        }
        var fieldGroup = [];
        fieldGroup.push({
            className: "col-12 col-md-12 col-xl-12",
            type: "select",
            key: "group",
            templateOptions: {
                label: this.translateService.instant("settings.document.group"),
                placeholder: this.translateService.instant("settings.document.group"),
                required: true,
                multiple: false,
                default: "amministrativo",
                options: [
                    {
                        value: "amministrativo",
                        label: "Gestionale amministrativo",
                    },
                    {
                        value: "contratti",
                        label: "Contratti fornitura e servizi",
                    },
                    {
                        value: "tecnico",
                        label: "Tecnica",
                    },
                    {
                        value: "unitaImmobiliari",
                        label: "Unità Immobiliari",
                    },
                ],
            },
        });
        fieldGroup.push({
            className: "col-12 col-md-5 col-xl-5",
            type: "input",
            key: "translation.it",
            defaultValue: "",
            templateOptions: {
                label: this.translateService.instant("settings.document.it"),
                placeholder: this.translateService.instant("settings.document.it"),
                required: true,
                minLength: 2,
                maxLength: 100,
            },
        });
        fieldGroup.push({
            className: "col-12 col-md-5 col-xl-5",
            type: "input",
            key: "translation.en",
            defaultValue: "",
            templateOptions: {
                label: this.translateService.instant("settings.document.en"),
                placeholder: this.translateService.instant("settings.document.en"),
                required: true,
                minLength: 2,
                maxLength: 100,
            },
        });
        fieldGroup.push({
            className: "col-12 col-md-2 col-xl-2",
            type: "select",
            key: "deleted",
            templateOptions: {
                label: this.translateService.instant("settings.document.deleted"),
                placeholder: this.translateService.instant("settings.document.deleted"),
                required: true,
                multiple: false,
                default: false,
                options: [
                    {
                        value: false,
                        label: "No",
                    },
                    {
                        value: true,
                        label: "Sì",
                    },
                ],
            },
        });
        this.fields = [
            {
                fieldGroupClassName: "row",
                fieldGroup: fieldGroup,
            },
        ];
        this.formNewIsVisible = true;
    };
    /**
     * Handle submit form new area
     *
     * @since 1.0.0
     */
    DocumentDetailComponent.prototype.onNewFormSubmit = function (model) {
        var _this = this;
        // Prevent invalid form submit
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
            console.warn(this.form);
            return;
        }
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.confirm.title"),
                message: this.translateService.instant("settings.document.dialog.saveMessage"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
            },
            width: "500px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            // Remove blank values from model
            Object.keys(model).forEach(function (key) {
                if (!model[key] || model[key].valueOf() === "") {
                    delete model[key];
                }
            });
            _this.cardIsLoading = true;
            var dataToSend = {
                documents: {
                    group: _this.form.value.group,
                    translation: _this.form.value.translation,
                    deleted: _this.form.value.deleted,
                }
            };
            _this.subscriptions.push(_this.settingsService
                .createDocument(_this.documentTemplateId, undefined, undefined, dataToSend)
                .pipe(finalize(function () { return (_this.cardIsLoading = false); }))
                .subscribe(function (res) {
                if (res) {
                    _this.formNewIsVisible = false;
                    _this.formFirstLevelIsVisible = false;
                    _this.formNewSubElementIsVisible = false;
                    _this.onGetDocument();
                    _this.toastrService.success(res.message);
                }
            }, function (err) {
                // Choose one of the following error handling method.
                // 1) First one show a message right under the form fields
                //    (if the form is properly setted)
                // 2) Second one is used to show a mat-error under each field
                //    in the dynamic form (is meant to be used only in dynamicForm)
                // 3) Third one show toastr notifications for each error
                // 4) Fourth one is used to show mat-error under each field
                //    in the ngx-formly form (is mean to be used only with ngx-formly)
                // this.helperService.handleFormError(form, err);
                // this.helperService.handleDynamicFormError(form, err);
                _this.helperService.handleError(err);
                _this.helperService.handleFormlyError(_this.form, err);
            }));
        });
    };
    /**
     * Handle add new element of document area
     *
     * @since 1.0.0
     */
    DocumentDetailComponent.prototype.onAddSubDocumentTemplate = function () {
        this.formNewSubElementIsVisible = true;
        if (this.modelSubElement) {
            for (var property in this.modelSubElement) {
                delete this.modelSubElement[property];
            }
        }
        var fieldGroup = [];
        fieldGroup.push({
            key: "elementType",
            defaultValue: "object",
            templateOptions: {
                type: "hidden",
            },
        });
        fieldGroup.push({
            key: "structure",
            defaultValue: "",
            templateOptions: {
                type: "hidden",
            },
        });
        // fieldGroup.push({
        //   className: "col-12 col-md-12 col-xl-12",
        //   type: "select",
        //   key: "elementType",
        //   templateOptions: {
        //     label: this.translateService.instant("settings.document.group"),
        //     placeholder: this.translateService.instant("settings.document.group"),
        //     required: true,
        //     multiple: false,
        //     default: "object",
        //     options: [
        //       {
        //         value: "object",
        //         label: "Facoltativo",
        //       },
        //       {
        //         value: "array",
        //         label: "Dipendente dalla mappatura",
        //       },
        //     ],
        //   },
        // });
        fieldGroup.push({
            className: "col-12 col-md-5 col-xl-5",
            type: "input",
            key: "translation.it",
            defaultValue: "",
            templateOptions: {
                label: this.translateService.instant("settings.document.it"),
                placeholder: this.translateService.instant("settings.document.it"),
                required: true,
                minLength: 2,
                maxLength: 100,
            },
        });
        fieldGroup.push({
            className: "col-12 col-md-5 col-xl-5",
            type: "input",
            key: "translation.en",
            defaultValue: "",
            templateOptions: {
                label: this.translateService.instant("settings.document.en"),
                placeholder: this.translateService.instant("settings.document.en"),
                required: true,
                minLength: 2,
                maxLength: 100,
            },
        });
        fieldGroup.push({
            className: "col-12 col-md-2 col-xl-2",
            type: "select",
            key: "deleted",
            templateOptions: {
                label: this.translateService.instant("settings.document.deleted"),
                placeholder: this.translateService.instant("settings.document.deleted"),
                required: true,
                multiple: false,
                default: false,
                options: [
                    {
                        value: false,
                        label: "No",
                    },
                    {
                        value: true,
                        label: "Sì",
                    },
                ],
            },
        });
        this.fieldsSubElement = [
            {
                fieldGroupClassName: "row",
                fieldGroup: fieldGroup,
            },
        ];
    };
    /**
     * Handle submit form new element of area
     *
     * @since 1.0.0
     */
    DocumentDetailComponent.prototype.onNewSubElementFormSubmit = function (model) {
        var _this = this;
        // Prevent invalid form submit
        if (this.formSubElement.invalid) {
            Object.keys(this.formSubElement.controls).forEach(function (key) {
                _this.formSubElement.controls[key].markAsTouched();
            });
            this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
            console.warn(this.formSubElement);
            return;
        }
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.confirm.title"),
                message: this.translateService.instant("settings.document.dialog.saveMessage"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
            },
            width: "500px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            // Remove blank values from model
            Object.keys(model).forEach(function (key) {
                if (!model[key] || model[key].valueOf() === "") {
                    delete model[key];
                }
            });
            _this.cardIsLoading = true;
            var dataToSend = {
                documents: {
                    translation: _this.formSubElement.value.translation,
                    deleted: _this.formSubElement.value.deleted,
                    elementType: _this.formSubElement.value.elementType,
                    structure: _this.formSubElement.value.structure,
                }
            };
            _this.subscriptions.push(_this.settingsService
                .createDocument(_this.documentTemplateId, _this.subDocumentTemplateId, undefined, dataToSend)
                .pipe(finalize(function () { return (_this.cardIsLoading = false); }))
                .subscribe(function (res) {
                if (res) {
                    _this.onGetDocument();
                    _this.formNewSubElementIsVisible = false;
                    _this.toastrService.success(res.message);
                }
            }, function (err) {
                // Choose one of the following error handling method.
                // 1) First one show a message right under the form fields
                //    (if the form is properly setted)
                // 2) Second one is used to show a mat-error under each field
                //    in the dynamic form (is meant to be used only in dynamicForm)
                // 3) Third one show toastr notifications for each error
                // 4) Fourth one is used to show mat-error under each field
                //    in the ngx-formly form (is mean to be used only with ngx-formly)
                // this.helperService.handleFormError(form, err);
                // this.helperService.handleDynamicFormError(form, err);
                _this.helperService.handleError(err);
                _this.helperService.handleFormlyError(_this.form, err);
            }));
        });
    };
    return DocumentDetailComponent;
}());
export { DocumentDetailComponent };
